import { ref } from "vue-demi";
import { TInputRule } from "@nationbetter/nb-components/src/models/Input";
import { REs } from "./REs";

export const isEmailValid = ref(false);

export const emailRules: TInputRule[] = [
  (v) => {
    const isRequired = !!v || "Required";
    if (isRequired !== true) {
      isEmailValid.value = false;
      return isRequired;
    }

    const valid = REs.email.test(String(v).toLowerCase());
    isEmailValid.value = valid;
    return valid || "Oops! This doesn't look like a valid email";
  },
];
